<script>/* eslint-disable */</script>
<template>

    <div class=" w-100" style="position:relative">

        <div class="row ml-2">
            
            <div class="form-input  col-md-3 mt-auto mb-auto">
                <input v-on:keyup.enter="search()"  class="form-control" type="text" v-model="searchParam" placeholder="Search By Location Map">
            </div>
            <div class="col-md-1 mt-auto mb-auto">
                <button class="btn btn-primary" @click="search()">Search</button>
            </div>
            <div class="form-input col-md-2 mt-auto mb-auto pl-4">
                <input class="form-check-input" type="checkbox" v-model="showRadius" id="defaultCheck1">
                <label class="form-check-label ml-3" style="font-size:14px">
                    Hide Dealer Area
                </label>
            </div>
            <div v-if="type == 'territory' || type == 'territorySalesByDocument'" class="col-md mt-auto mb-auto">
                <!-- Sales By Document -->
                <label>Sales By</label>
                <br>
                <toggle-button 
                    v-model="changeDocument"
                    :width="150"
                    :height="25"
                    color="#7dCE94" 
                    :sync="true" 
                    :labels="{checked: 'Document', unchecked: 'Scan'}"
                />

				
            </div>
            <div v-if="type == 'territory' || type == 'territorySalesByDocument'" class="col-md mt-auto mb-auto">
                <!-- Sales By Document -->
                <label>Competitor & POS</label>
                <br>
                <toggle-button 
                    v-model="showCompetitor"
                    :width="150"
                    :height="25"
                    color="#7dCE94" 
                    :sync="true" 
                    :labels="{checked: 'Reveal', unchecked: 'Hide'}"
                />

				
            </div>
            <div v-if="type == 'territory' || type == 'territorySalesByDocument'" class="col-md mt-auto mb-auto">
                <!-- Sales By Document -->
                <label>Service Date</label>
                <br>
                <toggle-button 
                    v-model="toggleServiceDate"
                    :width="150"
                    :height="25"
                    color="#7dCE94" 
                    :sync="true" 
                    :labels="{checked: 'Enabled', unchecked: 'Disabled'}"
                />

				
            </div>
            
        </div>

        <div style="position:relative">

            <div  class="" style="z-index:3;position:absolute;right:20px;bottom:30px;" :style="{'width' : hide ? '35%': '15%'}" v-if="!loading" :noExpand="true">
                <div class="row pl-3 rounded shadow" style="background-color:rgba(255 , 255, 255 ,1);margin-right:-20px">
                    <div class="col-1 mt-auto mb-auto" :class="{'col-12 pt-3 pb-3 pr-1' : !hide}">
                        <i class="fa fa-chevron-right" v-if="hide" @click="hide = !hide"></i>
                        <div  v-else @click="hide = !hide" class="hoverLegend p-2">
                            
                            <i class="fa fa-chevron-left" > Show Legend</i>
                        </div>
                    </div>
                    <div class="col-11 pl-3" style="font-size:10px;" v-if="hide">

                        <div class="row " >

                            <template v-if="mapType == 'By Kecamatan'">
                                <div class="row col-6 mt-1" v-for="(data , index ) in legendPoint" >
                                    <div class="col-md-4 " style="padding-top:3px;padding-bottom:3px"><span :style="data.style"></span></div>
                                    <div class="col-md-7 offset-md-1" style="padding-top:3px;padding-bottom:3px"><b>{{data.type}}</b></div>
                                </div>
                                <div class="row col-6 mt-1" v-for="(data , index ) in dealerRadiusLegend" >
                                    <div class="col-md-2">
                                        <input type="checkbox" :value="data.desc" v-model="tickLegend"/>
                                    </div>
                                    <div class="col-md-3 mt-2" style="padding-top:5px;padding-bottom:3px" v-if="data.shape != 'pentagon' "><span :class="data.shape" style="width:0.75rem;height:0.75rem;"></span></div>
                                    <div class="col-md-3 mt-2" style="padding-top:3px;padding-bottom:3px" v-else >
                                        <svg width="0.75rem" height="0.75rem" viewBox="-1 0 101 100" style="transform:rotate(180deg)">
                                            <path d="M20,0 L80,0 L100,60 L50,100 L0,60z" stroke="black" fill="black" />
                                        </svg>
                                    </div>
                                    
                                    <div class="col-md-6 offset-md-1 mt-2" style="padding-top:3px;padding-bottom:3px"><b>{{data.desc}}</b></div>
                                </div>
                                <hr>
                            </template>
                            <template v-else-if="mapType == 'By Dealer Radius' || mapType == 'By Dealer Range'">
                                <div class="row col-6 mt-2" v-for="(data , index ) in dealerRadiusLegend" >
                                    <div class="col-md-2">
                                        <input type="checkbox" :value="data.desc" v-model="tickLegend"/>
                                    </div>
                                    <div class="col-md-3 mt-2" style="padding-top:5px;padding-bottom:3px" v-if="data.shape != 'pentagon' "><span :class="data.shape" style="width:0.75rem;height:0.75rem;"></span></div>
                                    <div class="col-md-3 mt-2" style="padding-top:3px;padding-bottom:3px" v-else >
                                        <svg width="0.75rem" height="0.75rem" viewBox="-1 0 101 100" style="transform:rotate(180deg)">
                                            <path d="M20,0 L80,0 L100,60 L50,100 L0,60z" stroke="black" fill="black" />
                                        </svg>
                                    </div>
                                    
                                    <div class="col-md-6 offset-md-1 mt-2" style="padding-top:3px;padding-bottom:3px"><b>{{data.text}}</b></div>
                                </div>
                                
                                
                            </template>
                            
                            <!-- {{type}} -->
                            <div class="col-12 pr-3">
                                <div style="border-top: 1px solid #AAA"></div>
                                <div class="row">
                                    <div class="col-md-7 pl-4">Status</div>
                                    <div class="col-md-2 pl-3">Unit</div>
                                    <div class="col-md-2 pl-3">%</div>
                                </div>
                                <template v-if="type =='territory'">
                                    <div class="row col"  v-for="(data , index ) in purchaseLegend"  style="padding-top:0px;padding-bottom:0px">
                                        <div class="col-md-2 "  style="padding-top:10px;padding-bottom:3px"><span class="icon" :style="{'background-color'  : data.color}"></span></div>
                                        <div class="col-md-6" style="padding-top:5px;padding-bottom:3px"><b>{{data.text}}</b></div>
                                        <div class="col-md-2 "  style="padding-top:10px;padding-bottom:3px"><span class="h6">{{numberWithCommas(data.count)}}</span></div>
                                        <div class="col-md-2 "  style="padding-top:10px;padding-bottom:3px"><span class="h6">{{data.total ? Math.round(data.count / data.total * 100) : 0}} %</span></div>
                                    </div>
                                </template>
                                <template v-else-if="type == 'territoryService'">
                                    <div class="row col"  v-for="(data , index ) in serviceLegend"  style="padding-top:0px;padding-bottom:0px">
                                        <div class="col-md-2 "  style="padding-top:10px;padding-bottom:3px"><span class="icon" :style="{'background-color'  : data.color}"></span></div>
                                        <div class="col-md-6" style="padding-top:5px;padding-bottom:3px"><b>{{data.text}}</b></div>
                                        <div class="col-md-2 "  style="padding-top:10px;padding-bottom:3px"><span class="h6">{{numberWithCommas(data.count)}}</span></div>
                                        <div class="col-md-2 "  style="padding-top:10px;padding-bottom:3px"><span class="h6">{{data.total ? Math.round(data.count / data.total * 100) : 0}} %</span></div>
                                    </div>
                                </template>
                            </div>
                            
                        </div>
                </div>
                    
                </div>
                
                
                
            </div>
            <div class="ml-4 mt-2"> <h6>Current Map Zoom Level : {{zoom}}</h6></div>
            <l-map
            v-if="!loading"
            :center="center"
            :zoom="zoom"
            ref="map"
            style="min-height:650px;width:100%;z-index:0;position:relative"
            @update:zoom="zoomUpdated"
            >   
                    <l-circle 
                        :lat-lng="latLng(dealer[0].lat , dealer[0].lng)"
                        :radius="10000000"
                        :fillColor="'#FFFFFF'"
                        :fillOpacity="0.55"
                        :color="'#46769A'"
                        :weight="1"
                    />

                <l-tile-layer
                    :url="url"
                    :attribution="attribution"
                />
                
                <div v-if="mapType == 'By Kecamatan'">
                
                    <l-geo-json
                        v-if="show"
                        :geojson="geojsonOther"
                        :options="options"
                        :options-style="styleFunction('#C39E56')"
                    />
                    <l-geo-json
                        v-if="show"
                        :geojson="geojsonRing1"
                        :options="options"
                        :options-style="styleFunction('#F21C1E')"
                    />
                    <l-geo-json
                        v-if="show"
                        :geojson="geojsonRing2"
                        :options="options"
                        :options-style="styleFunction('#AF73F2')"
                    />
                    <l-geo-json
                        v-if="show"
                        :geojson="geojsonRing3"
                        :options="options"
                        :options-style="styleFunction('#668DAB')"
                    />
                    <l-geo-json
                        v-if="show"
                        :geojson="geojsonLocation"
                        :options="options"
                        :options-style="styleFunction('#CCE85A')"
                    />
                </div>

                
                <div v-else-if="(mapType == 'By Dealer Radius' || mapType == 'By Dealer Range') && !showRadius">
                    <l-circle 
                        v-for="(circle , index) in configRadius"
                        
                        :lat-lng="latLng(dealer[0].lat , dealer[0].lng)"
                        :radius="circle.distance"
                        :fillColor="circle.color"
                        :fillOpacity="0"
                        :color="circle.color"
                        :weight="1"
                    />
                    <!-- <l-circle 
                        :lat-lng="latLng(dealer[0].lat , dealer[0].lng)"
                        :radius="10000"
                        :fillColor="'#938032'"
                        :fillOpacity="0"
                        :color="'#938032'"
                        :weight="1"
                    />
                    <l-circle 
                        :lat-lng="latLng(dealer[0].lat , dealer[0].lng)"
                        :radius="5000"
                        :fillColor="'#F21C1E'"
                        :fillOpacity="0"
                        :color="'#B177F2'"
                        :weight="1"
                    /> -->
                    
                    
                </div>
                <l-geo-json
                    v-if="searchGeoJSon"
                    :geojson="searchGeoJSon"
                    :options="options"
                    :options-style="styleFunction('#000')"
                />
                
                

                
                <!-- <v-marker-cluster> -->
                <template v-if="zoom > 9 && type == 'territorySalesByDocument'">
                    <l-marker v-for="(data , index) in midPoints" :lat-lng="latLng(data.coordinates[0] , data.coordinates[1])"  :icon="data.icon">
                        <l-icon
                            class="custom-icon"
                        >
                            <div class="headline">
                                <h6 style="color:black">{{ data.value }}</h6>
                            </div>
                        
                        </l-icon>
                    </l-marker>
                </template>
                
                <template v-else-if="type != 'territorySalesByDocument' && zoom > 9">
                    <template v-for="(data , index) in midPoints">
                        <!-- <l-marker v-if="!showKecamatan.includes(data.kecamatan)"  :lat-lng="latLng(data.coordinates[1] , data.coordinates[0])"  :icon="data.icon" @click="showPoints(data.kecamatan)"> -->
                        <l-marker :lat-lng="latLng(data['coordinates' + zoom][1] , data['coordinates' + zoom][0])"  :icon="data.icon" @click="showPoints(data.kecamatan , data.legend)" v-if="data.value != 0"> 
                            <l-icon
                                class="custom-icon"
                                
                            >
                                <div class="headline" style="border-radius:100%;padding-top:5px" :style="{'background-color' :  data.color ? data.color : 'white'}">
                                    <h6 style="color:black">{{ data.value }}</h6>
                                </div>
                            
                            </l-icon>
                        </l-marker>
                    </template>
                    <template v-for="keys in showKecamatan">
                        <l-marker v-for="(data , index) in newShowData[keys]" :lat-lng="latLng(data.lat , data.lng)"  :icon="data.icon">
                            <l-tooltip :content="data.contentText"/>
                        </l-marker>
                    </template>
                </template> 

                <template v-if="showCompetitor">
                    <l-marker v-for="(competitor, index) in competitorData" :lat-lng="latLng(competitor.lat , competitor.lng)" :icon="competitor.icon" >
                        <l-popup :content="competitor.hoverHtml"/>
                    </l-marker>
                    <l-marker :icon="posMarkerIcon" v-for="(dealer, index) in pos.filter(x => x.kd_dealer != curDealer)" :lat-lng="latLng(dealer.lat , dealer.lng)">
                        <l-popup :content="`POS Dealer : <b>${dealer.kd_dealer} - ${dealer.name}</b>`"/>
                    </l-marker>
                    <l-marker :icon="curPosMarkerIcon" v-for="(dealer, index) in pos.filter(x => x.kd_dealer == curDealer)" :lat-lng="latLng(dealer.lat , dealer.lng)">
                        <l-popup :content="`POS Dealer : <b>${dealer.kd_dealer} - ${dealer.name}</b>`"/>
                    </l-marker>
                </template>
                <l-marker v-for="(dealer, index) in dealer" :lat-lng="latLng(dealer.lat , dealer.lng)" :icon="dealerMarkerIcon"  :zIndexOffset="1000">
                    <l-popup :content="'Dealer Name : <b>' + dealer.dealer.name + '</b>' "/>
                </l-marker>
                <l-marker v-for="(dealer, index) in otherDealer" :lat-lng="latLng(dealer.lat , dealer.lng)" :icon="OtherDealerMarkerIcon" :zIndexOffset="-100">
                    <l-popup :content="`Dealer Name : <b> ${dealer.loc_code} - ${dealer.name}  </b>` "/>
                </l-marker>
                <!-- </v-marker-cluster>  -->

            </l-map>
        </div>
        
        
        <MarketContribution 
            v-if="dataMarket && dataMarketDocs && dataMarketDealer"
            :dataMarket="dataMarket"
            :dataMarketDocs="dataMarketDocs"
            :dataMarketDealer="dataMarketDealer"
            :dealerRadiusLegend="dealerRadiusLegend"
            :trendSales="trendSales"
        />

    </div>
</template>


<script>
/*

    Have Mercy on your soul reading this code :) - Marvin

*/
import { latLng , icon , divIcon , map, geoJSON } from "leaflet";
import { LMap, LTileLayer, LMarker, LGeoJson, LIcon, LPopup, LTooltip, LCircle } from "vue2-leaflet";
import Vue2LeafletMarkerCluster from 'vue2-leaflet-markercluster'
import "leaflet.markercluster/dist/MarkerCluster.css";
import "leaflet/dist/leaflet.css"
import "leaflet.markercluster/dist/MarkerCluster.Default.css";
import moment from 'moment'
import MarketContribution from './MarketContribution.vue'
// const XLSX = require('xlsx')
const XLSX = require('xlsx')

import { ToggleButton } from 'vue-js-toggle-button'
export default {
    components: {
        LMap,
        LTileLayer,
        LIcon,
        LGeoJson,
        LMarker,
        LPopup,
        LTooltip,
        LCircle,
        'v-marker-cluster': Vue2LeafletMarkerCluster,
        ToggleButton,
        MarketContribution
    },
    props : ['area' , 'data' , 'geojson' , 'mapType', 'type' , 'toggleService' , 'dataMarket', 'dataMarketDocs' , 'dataMarketDealer' , 'trendSales'],
    data() {
        return {
            hide : false,
            pos : null,
            toggleServiceDate : this.toggleService,
            latLng : latLng,
            searchParam : '',
            showCompetitor : false,
            midPoints : null,
            loading: false,
            show: true,
            enableTooltip: true,
            searchGeoJSon : null,
            purchaseLegend : [{
                text : 'Purchase',
                color : '#BC236F ',
                count : 0,
                total : 0
            }, {
                text : 'Purchase Lost',
                color : '#4CDEC0 ',
                count : 0,
                total : 0
            }, {
                text : 'Purchase - Service Current Dealer',
                color : '#668DAB ',
                count : 0,
                total : 0
            }, {
                text : 'Purchase - Service Other Dealer',
                color : '#78AB66 ',
                count : 0,
                total : 0
            }
            // {
            //     text : 'Lokasi',
            //     color : '#CCE85A '
            // }
            ],
            serviceLegend : [{
                text : 'Service',
                compare_text : 'service',
                color : '#BC236F ',
                count : 0,
                total : 0
            }, {
                text : 'Service - Service Current Dealer',
                compare_text : 'service - service current dealer',
                color : '#CCE85A ',
                count : 0,
                total : 0
            }, {
                text : 'Service - Service Other Dealer',
                compare_text : 'service - service other dealer',
                color : '#CCE85A ',
                count : 0,
                total : 0
            }, {
                text : 'Service - Lost',
                compare_text : 'service lost',
                color : '#4CDEC0 ',
                count : 0,
                total : 0
            }
            ],
            changeDocument : false,
            legends : [{
                text : 'Lokasi',
                color : '#CCE85A ',
                shape : 'icon'
            },{
                text : 'Ring 1',
                color : '#F21C1E ',
                shape : 'triangle'
            },{
                text : 'Ring 2',
                color : '#AF73F2 ',
                shape : 'diamong'
            },{
                text : 'Ring 3',
                color : '#668DAB',
                shape : 'hea'
            },{
                text : 'Other',
                color : '#C39E56',
                shape : ''
            }
            // {
            //     text : 'Other',
            //     color : '#94A3B2'
            // }
            ],
            dealerRadiusLegend : null,
            dealerRangeLegend : [{
                color : '#F36F21',
                text : 'Purchase',
            },{
                color : '#DCF965',
                text : 'Ring 1'
            },{
                color : '#E94143',
                text : 'Ring 2'
            },{
                color : '#B583EE',
                text : 'Ring 3'
            }],
            legendPoint : null,
            zoom: 11,
            showRadius : this.mapType == 'By Dealer Radius' ? true : false,
            center: null,
            geojsonOther : null,
            geojsonRing1 : null,
            geojsonRing2 : null,
            geojsonRing3 : null,
            geojsonLocation : null,
            breachingOthers : null,
            fillColor: "#EE82EE",
            url: 'https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png',
            attribution:
                '&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors',
            dealer : null,
            processedData : null,
            moment,
            content : false,
            contentText : '',
            reload : true,
            configRadius : [],
            tickLegend : null,
            newShowData : [],
            showKecamatan : [],
            curDealer : null,
            otherDealer : []
        };
    },
    computed: {
        options() {
            return {
                onEachFeature: this.onEachFeatureFunction
            };
        },
        dealerMarkerIcon () {
            let height = 25 + Math.max(0 , (this.zoom - 11) * 5)
            let width = 25 + Math.max(0 , (this.zoom - 11) * 5)
            return icon({
                iconUrl: '/honda.png',
                iconSize:      [width, height], // size of the icon
                // iconAnchor:   [22, 94], // point of the icon which will correspond to marker's location
            });
        },
        OtherDealerMarkerIcon () {
            let height = 25 + Math.max(0 , (this.zoom - 11) * 5)
            let width = 25 + Math.max(0 , (this.zoom - 11) * 5)
            return icon({
                iconUrl: '/Honda-w.svg',
                iconSize:      [width, height], // size of the icon
                // iconAnchor:   [22, 94], // point of the icon which will correspond to marker's location
            });
        },
        posMarkerIcon () {
            let height = 25 + Math.max(0 , (this.zoom - 11) * 5)
            let width = 25 + Math.max(0 , (this.zoom - 11) * 5)
            return icon({
                iconUrl: '/pos.svg',
                iconSize:      [width, height], // size of the icon
                // iconAnchor:   [22, 94], // point of the icon which will correspond to marker's location
            });
        },
        curPosMarkerIcon () {
            let height = 25 + Math.max(0 , (this.zoom - 11) * 5)
            let width = 25 + Math.max(0 , (this.zoom - 11) * 5)
            return icon({
                iconUrl: '/ttmMarker/pos-red.svg',
                iconSize:     [width, height], // size of the icon
                // iconAnchor:   [22, 94], // point of the icon which will correspond to marker's location
            });
        },
        
        onEachFeatureFunction() {
            if (!this.enableTooltip) {
                return () => {};
            }
            return (feature, layer) => {
                // console.log(layer)
                if(feature.properties.typeDealer) {
                    layer.bindTooltip(
                        `</div><div>${feature.properties.typeDealer}: ` +
                        feature.properties.ADM3_EN +
                        "</div><div>Nama Kota: " +
                        feature.properties.ADM2_EN +
                        "</div><div>Total: "+
                        feature.properties.total +
                        "</div><div>Market Contribution: "+
                        feature.properties.mark_contribution
                        //  +"</div><div>Breach: "+
                        // feature.properties.breach +
                        // "</div>"
                    ,
                    { permanent: false, sticky: true }
                    );
                }
                else {
                    layer.bindTooltip(
                        `</div><div>Nama Lokasi : ${feature.properties.display_name}</div>`
                    ,
                    { permanent: false, sticky: true }
                    );
                }
                
            };
        }
    },
    watch : {
        type : function () {
            this.processData()
        },
        changeDocument : function () {
            this.$emit('changeDoc' , this.changeDocument ? 'Sales By Document' : 'Sales')
        },
        toggleServiceDate : function () {
            this.$emit('toggleServiceDate' , this.toggleServiceDate)
        },
        tickLegend : {
            deep : true,
            handler () {
                let vm = this

                if(vm.type == 'territorySalesByDocument')
                    return

                let listLegend = vm.tickLegend
                
                this.showData = this.processedData.filter( x => listLegend.includes(x.desc_legend))

                console.log(listLegend)
                // console.log(this.showData)

                let dealerData = this.data.dealer
                let midPoints = []

                let otherAreaDealer = dealerData.area.filter(x => x.ring == 'OTHER').map(x => x.id_kecamatan)
                let ring3Dealer = dealerData.area.filter(x => x.ring == 'RING 3').map(x => x.id_kecamatan)
                let ring2Dealer = dealerData.area.filter(x => x.ring == 'RING 2').map(x => x.id_kecamatan)
                let ring1Dealer = dealerData.area.filter(x => x.ring == 'RING 1').map(x => x.id_kecamatan)
                let locationDealer = dealerData.area.filter(x => x.ring == 'LOKASI').map(x => x.id_kecamatan)

                this.calculateFeatures('geojsonOther', 'Other' , otherAreaDealer , dealerData , midPoints , listLegend)
                this.calculateFeatures('geojsonRing1', 'Ring 1' , ring1Dealer , dealerData , midPoints , listLegend)
                this.calculateFeatures('geojsonRing2', 'Ring 2' , ring2Dealer , dealerData , midPoints , listLegend)
                this.calculateFeatures('geojsonRing3', 'Ring 3' , ring3Dealer , dealerData , midPoints , listLegend)
                this.calculateFeatures('geojsonLocation', 'Lokasi' , locationDealer , dealerData , midPoints , listLegend)

                this.midPoints = midPoints

                this.seperateKecamatan()
            }
        },
    },
    async created() {
        this.loading = true;
        this.processData()
    },
    methods : {
        // Show Points of Icon / Kecamatan / Legend
        showPoints (kecamatan , legend) {
            if(this.showKecamatan.includes(kecamatan + '-' + legend)){
                let index = this.showKecamatan.indexOf(kecamatan + '-' + legend)
                this.showKecamatan.splice(index , 1)
            }
            else {
                this.showKecamatan.push(kecamatan + '-' + legend)
            }
        },
        // Function to seperate Kecamatan and ICON / Legend
        seperateKecamatan () {
            let obj = {}


            for(var i = 0 ; i < this.showData.length ; i++) {
                let point = this.showData[i]

                // console.log(point)
                if(obj[point.kecamatan + '-' + point.legend.toLowerCase()])
                    obj[point.kecamatan + '-' + point.legend.toLowerCase()].push(point)
                else {
                    obj[point.kecamatan + '-' + point.legend.toLowerCase()] = [point]
                }

            }

            this.newShowData = obj
        },
        createIcon (nameOfBrand) {
            return icon({
                iconUrl: `/ttmMarker/${nameOfBrand.toLowerCase()}.svg`,
                iconSize:     [25, 25], // size of the icon
            });
        },
        exportExcel () {
            if(!this.processedData) return

            let rawData = this.processedData.map(x => ({
                ring : x.ring,
                frame_no : x.frame_no,
                engine_no : x.engine_no,
                type_code : x.type_code,
                commercial_name : '-',
                tgl_sales : x.sales_date,
                nama_pemilik : x.owner_name,
                tgl_service : x.last_service_date,
                sold_kota : x.sold_kota,
                sold_kecamatan : x.sold_kecamatan,
                sold_kelurahan : x.sold_kelurahan,
                phone_number : x.phone_number,
                commercial_name : x.commercial_name,
                alamat_domisili : x.address,
                kategori : x.legend,
                kota_ssu : x.kota_ssu,
                kecamatan_ssu : x.kecamatan_ssu,
                kelurahan_ssu : x.kelurahan_ssu,
                kota_scan : x.kota_scan,
                kecamatan_scan : x.kecamatan_scan,
                kelurahan_scan : x.kelurahan_scan,
            
            }))

            let wb = XLSX.utils.book_new()
            let ws = XLSX.utils.json_to_sheet(rawData, {raw: true})
            XLSX.utils.book_append_sheet(wb, ws, "Data")
            XLSX.writeFile(wb, `Territory ${this.type == 'territory' ? 'Sales' : 'Service'}.xls`)


        },
        zoomUpdated (zoom) {
            this.zoom = zoom;
        },
        // Search Area and Insert Geojson in Map ( Textfield Search )
        search () {
            this.$http.get('/api/highlight/territory-management/nominatim?q=' + this.searchParam)
            .then((resp) => {
                let data = resp.data.data
                this.searchGeoJSon = data.geojson
                let location = data.location
                if(location) {
                    location = location[0]
                    this.center = [location.lat , location.lon]
                    this.$refs.map.fitBounds([
                        [location.boundingbox[0] , location.boundingbox[2]],
                        [location.boundingbox[1] , location.boundingbox[3]]
                    ])

                }
            })
            .catch((err) => {
                console.log(err)
                this.$store.dispatch('triggerAlert' , [false , 'Something went wrong. Please try again later.'])
            })
        },
        // Not In Used anymore.
        calculateDistance(index , lat , lng) {

            let dealer = this.dealer[0]
            let data = this.processedData[index]
            data.contentText = 'Loading......'

            this.$http.get(`/api/highlight/territory-management/route-distance?lat_destination=${lat}&long_destination=${lng}&lat_origin=${dealer.lat}&long_origin=${dealer.lng}`)
            .then((resp) => {
                let distance = ((parseFloat(resp.data.data) / 1000).toFixed(2)) + ' KM'
                data.contentText = 'Owner Name : <b>'+ data.owner_name + '</b><br>Purchase Dealer : <b>'+ data.purchase_dealer + '</b><br>Engine Number : <b>' + data.engine_no +'</b><br>Vehicle Type : <b>' + data.type + '</b><br>Delivery Date : <b>' + moment(data.activity_date).format('Y-MM-DD HH:mm')+'</b>' + '<br> Lat : <b>' + data.lat + '</b>, Lng : <b>' + data.lng + '</b>' + '<br> Distance : <b>' + distance + '</b>'
                this.$set(this.processedData , index , data)
                this.processedData = this.processedData.sort((a, b) => {return b.lat - a.lat})
            })
            .catch((err) => {
                this.$store.dispatch('triggerAlert' , [false , 'Failed to calculate distance from Dealer to Point.'])
                alert('Failed to calculate distance from Dealer to Point.')
                console.log(err)
            })
        },
        styleFunction(fillColor) { // important! need touch fillColor in computed for re-calculate when change fillColor
            return () => {
                return {
                    weight: 2,
                    color: "#555",
                    opacity: 1,
                    fillColor: fillColor,
                    fillOpacity: 0.36,
                };
            };
        },
        // Function to Add Distance to a Lat Lng of Midpoint of a Karesidenan
        async addDistanceToMidPoint(lat , lng , type , distance) {
            if(distance < 0.2) {
                distance = 0.15
            }

            if(distance >= 1.2) {
                distance = 1.5
            }

            switch(type) {
                case 0:
                    lat = lat + (distance / 6378) * (180 / Math.PI)
                    lng = lng + (distance / 6378) * (180 / Math.PI)
                    break;
                case 1:
                    lng = lng - (distance / 6378) * (180 / Math.PI)
                    lat = lat - (distance / 6378) * (180 / Math.PI)
                    break;
                case 2:
                    lat = lat - (distance / 6378) * (180 / Math.PI)
                    lng = lng + (distance / 6378) * (180 / Math.PI)
                    break;
                case 3:
                    lat = lat + (distance / 6378) * (180 / Math.PI)
                    lng = lng - (distance / 6378) * (180 / Math.PI)
                    break;
            }

            return [lng , lat]
        },

        // Function To Seperate Each GEOJSON that is included in Dealer Area and Divided by RING
        calculateFeatures(selectedGeojson , typeDealer , areaDealer , dealerData , midPoints , exclusion) {
            let vm = this

            this[selectedGeojson] = {
                type : 'FeatureCollection'
            }
            this[selectedGeojson].features = this.geojson.features.filter(x => areaDealer.includes(x.properties.ADM3_PCODE))
            this[selectedGeojson].features.forEach(async function(e){
                let area = dealerData.area.find(x => x.id_kecamatan == e.properties.ADM3_PCODE)
                let pcode = e.properties.ADM3_PCODE
                e.properties.typeDealer = typeDealer
                e.properties.total = area.purchase ? area.purchase : area.sales ? area.sales : 0
                e.properties.mark_contribution = area.contribution + '%'

                if(area.latitude) {
                    vm.dealerRadiusLegend[4].count += area.sales ? area.sales : 0
                    if(vm.type == 'territorySalesByDocument') {
                        let value = area.purchase ? area.purchase : area.sales ? area.sales : area.service ? parseInt(area.service) + parseInt(area.service_lost) + parseInt(area.service_service_current_dealer) + parseInt(area.service_service_other_dealer) : 0
                        let obj = {
                            coordinates :[area.latitude , area.longitude],
                            value : value,
                            kecamatan : area.id_kecamatan,
                            legend : i
                        }
                        midPoints.push(obj)
                    }
                    else {
                        let selectedLegend = vm.type == 'territory' ? vm.purchaseLegend : vm.serviceLegend

                        let filterCriteria = vm.type == 'territory' ? 'text' : 'compare_text'



                        for(var i = 0 ; i < selectedLegend.length ; i++) {
                            let legend = selectedLegend[i]
                            let value = 0
                            let points = vm.data.points.filter(x => x.legend.toLowerCase() == legend[filterCriteria].toLowerCase() && x.kecamatan == pcode)

                            if(exclusion && !exclusion.includes(typeDealer)) {
                                value = 0
                            }
                            else if(!points || points.length == 0)
                                value = 0
                            else
                                value = points.length

                            

                            let obj = {
                                value : value,
                                kecamatan : area.id_kecamatan,
                                color : legend.color ? legend.color : '#FFF',
                                legend : legend[filterCriteria].toLowerCase()
                            }
                            // Set Coordinates of Icon in Map for every Zoom Level Supported.
                            for(var j = 10 ; j < 18 ; j++) {
                                obj['coordinates' + j] = await vm.addDistanceToMidPoint(area.latitude , area.longitude , i , (1.2 - (0.2 * (j - 10))))
                            }

                            midPoints.push(obj)
                        }
                    }
                }
            });
        },
        processData () {
            let newData = []
            let dealerMarker = []
            let dealerData = this.data.dealer

            console.log(this.geojson)

            // Mapping Competitor and Hover Text for Competitor Icon
            let competitorData = this.data.competitor ? this.data.competitor.map(x => ( 
            { 
                hoverHtml : `
                    Nama Channel : <b>${ x.nama_channel }</b><br>
                    Brand Motor : <b>${ x.brand }</b><br>
                    Alamat : <b>${ x.alamat }</b><br>
                    Average Sales : <b>${ x.avg_sales }</b><br>
                    Lat : <b>${ x.lat }</b>, Lng :  <b>${ x.lng }</b><br>
                    Distance From Dealer : <b>${ x.distance } KM</b><br>
                `,
                lat : x.lat,
                lng : x.lng,
                icon : this.createIcon(x.brand)
            })) : []

            this.competitorData = competitorData




            let midPoints = []
            // Define POS , Purchase Tab and Service Tab Data
            this.pos = dealerData.pos_dealer;
            this.purchaseLegend.map( x => x.count = 0)
            this.serviceLegend.map( x => x.count = 0)


            // Define Other Dealer Data from Data
            this.otherDealer = dealerData.other_dealer


            
            if(dealerData && !parseFloat(dealerData.lat) == 0 && !parseFloat(dealerData.lng) == 0)
                this.center = [dealerData.lat , dealerData.lng]
            else
                this.center = ["-7.257621004195039","112.75208164629598"]

            // Auto Config Ring Radius in Map Start
            let keys = Object.keys(dealerData)
            
            let arrayColor = ['#B177F2', '#938032' ,'#F21C1E']
            let curIndex = 0
            for(var i = 0 ; i < keys.length ; i++) {
                
                if(keys[i].includes('ring')) {
                    curIndex++;
                    let value = dealerData[keys[i]]
                    let splitName = keys[i].split('_')
                    let formattedName = `Ring ${splitName[1]}`

                    let obj = {
                        distance : value * 1000,
                        name : formattedName,
                        color : arrayColor[curIndex]
                    }

                    this.configRadius.push(obj)
                }
            }

            // Auto Config Ring Radius in Map End
            let vm = this

            let otherAreaDealer = dealerData.area.filter(x => x.ring == 'OTHER').map(x => x.id_kecamatan)
            let ring3Dealer = dealerData.area.filter(x => x.ring == 'RING 3').map(x => x.id_kecamatan)
            let ring2Dealer = dealerData.area.filter(x => x.ring == 'RING 2').map(x => x.id_kecamatan)
            let ring1Dealer = dealerData.area.filter(x => x.ring == 'RING 1').map(x => x.id_kecamatan)
            let locationDealer = dealerData.area.filter(x => x.ring == 'LOKASI').map(x => x.id_kecamatan)
            this.curDealer = dealerData.kd_dealer
            
            // Set Legend For Map
            this.dealerRadiusLegend = [{
                // color : '#9E5FE5',
                color : '#F21C1E',
                radiusColor : '#C39E56',
                text : `0 - ${dealerData.ring_1} KM`,
                desc : "Ring 1",
                distance : dealerData.ring_1,
                count : 0,
                total : this.data.points ? this.data.points.length : 0,
                shape : 'triangle'
            },{
                color : '#B177F2',
                radiusColor : '#F21C1E',
                text : `${dealerData.ring_1} - ${dealerData.ring_2} KM`,
                desc : "Ring 2",
                distance : dealerData.ring_2,
                count : 0,
                total : this.data.points ? this.data.points.length : 0,
                shape : 'diamond'
            },{
                color : '#668DAB',
                radiusColor : '#668DAB',
                text : `${dealerData.ring_2} - ${dealerData.ring_3} KM`,
                desc : "Ring 3",
                distance : dealerData.ring_3,
                count : 0,
                total : this.data.points ? this.data.points.length : 0,
                shape : 'pentagon'
            },{
                color : '#C39E56',
                radiusColor : '#58DE4C',
                text : `> ${dealerData.ring_3} KM`,
                desc : "Others",
                distance : '-',
                count : 0,
                total : this.data.points ? this.data.points.length : 0,
                shape : 'hexagonLegend'
            }]
            if(this.mapType == 'By Kecamatan') { 
                this.dealerRadiusLegend.unshift({
                    color : '#CCE85A',
                    text : `0 - ${dealerData.ring_1} KM`,
                    desc : "Lokasi",
                    distance : 0,
                    count : 0,
                    total : this.data.points ? this.data.points.length : 0,
                    shape : 'icon'
                })

                this.dealerRadiusLegend.push({
                    color : '#CCE85A',
                    text : `0 - ${dealerData.ring_1} KM`,
                    desc : "Pelanggaran Wilayah",
                    distance : 0,
                    count : 0,
                    total : this.data.points ? this.data.points.length : 0,
                    shape : 'fa fa-star'
                })
            }

            this.tickLegend = this.dealerRadiusLegend.map(x => x.desc)

            // Select and Seperate GEOJSON by Ring and Dealer's Area
            this.calculateFeatures('geojsonOther', 'Other' , otherAreaDealer , dealerData , midPoints , null)
            this.calculateFeatures('geojsonRing1', 'Ring 1' , ring1Dealer , dealerData , midPoints , null)
            this.calculateFeatures('geojsonRing2', 'Ring 2' , ring2Dealer , dealerData , midPoints , null)
            this.calculateFeatures('geojsonRing3', 'Ring 3' , ring3Dealer , dealerData , midPoints , null)
            this.calculateFeatures('geojsonLocation', 'Lokasi' , locationDealer , dealerData , midPoints , null)

            // Set Style for ICON
            let styleText = `
                
                width: 0.75rem;
                height: 0.75rem;
                display: block;
                
                position: relative;
            `

            // Data is not using By Document
            if(this.type != 'territorySalesByDocument') {
                for (var i = 0 ; i < this.data.points.length ; i++) {
                    // Check Distance By Kilometer
                    let distance = this.mapType == 'By Dealer Range' ? parseFloat(this.data.points[i].distance_road) / 1000 : parseFloat(this.data.points[i].distance) / 1000

                    // Determine Legend On Point Colors
                    let color = ''
                    let legendText = this.data.points[i].legend.toLowerCase()
                    if(this.type == 'territory' || this.type == 'territorySalesByDocument') {

                        
                        let curLegend = this.purchaseLegend.find(x => legendText == x.text.toLowerCase())
                        
                        color = curLegend ? curLegend.color : '#FFF'
                        curLegend ? curLegend.count++ : ''
                        curLegend ? curLegend.total = this.data.points.length : ''
                    }
                    else {
                        // console.log(legendText)
                        let curLegend = this.serviceLegend.find(x => legendText == x.compare_text.toLowerCase())
                        color = curLegend ? curLegend.color : '#FFF'
                        curLegend ? curLegend.count++ : ''
                        curLegend ? curLegend.total = this.data.points.length : ''
                    }

                    
                        
                    let shape = ''
                    let color_border = ''
                    // Count Data and Determine Shape of Icon for Every Ring Type Exist
                    if(this.mapType == 'By Kecamatan') {
                        
                        if(this.data.points[i].ring == 'LOKASI') {
                            // color_border = this.dealerRadiusLegend[0].color
                            this.dealerRadiusLegend[0].count++
                            this.data.points[i].desc_legend = this.dealerRadiusLegend[0].desc
                            shape += `circle`
                            
                        }
                        if(this.data.points[i].ring == 'RING 1') {
                            // color_border = this.dealerRadiusLegend[1].color
                            this.dealerRadiusLegend[1].count++
                            this.data.points[i].desc_legend = this.dealerRadiusLegend[1].desc
                            shape = `triangle`
                            // console.log(this.dealerRadiusLegend)
                        }
                            
                        else if (this.data.points[i].ring == 'RING 2'){
                            this.dealerRadiusLegend[2].count++
                            // color_border = this.dealerRadiusLegend[2].color
                            this.data.points[i].desc_legend = this.dealerRadiusLegend[2].desc
                            shape = `diamond`
                        }
                            
                        else if (this.data.points[i].ring == 'RING 3'){
                            // color_border = this.dealerRadiusLegend[3].color
                            this.dealerRadiusLegend[3].count++
                            this.data.points[i].desc_legend = this.dealerRadiusLegend[3].desc
                            shape = `pentagon`
                        }
                            
                        else if(this.data.points[i].ring == 'OTHER'){
                            // color_border = this.dealerRadiusLegend[4].color
                            this.dealerRadiusLegend[4].count++
                            this.data.points[i].desc_legend = this.dealerRadiusLegend[4].desc
                            shape = `hexagon`
                            
                        }

                        else if(this.data.points[i].ring == 'PELANGGARAN WILAYAH'){
                            // color_border = this.dealerRadiusLegend[4].color
                            this.dealerRadiusLegend[5].count++
                            this.data.points[i].desc_legend = this.dealerRadiusLegend[5].desc
                            shape = `fa fa-star`
                            
                        }
                    }
                    else {
                        if(distance <= dealerData.ring_1) {
                            color_border = this.dealerRadiusLegend[0].radiusColor
                            this.dealerRadiusLegend[0].count++
                            this.data.points[i].desc_legend = this.dealerRadiusLegend[0].desc
                            shape = `triangle`
                        }
                            
                        else if (distance > dealerData.ring_1 && distance <= dealerData.ring_2){
                            this.dealerRadiusLegend[1].count++
                            color_border = this.dealerRadiusLegend[1].radiusColor
                            this.data.points[i].desc_legend = this.dealerRadiusLegend[1].desc
                            shape = `diamond`
                        }
                            
                        else if (distance > dealerData.ring_2 && distance <= dealerData.ring_3){
                            color_border = this.dealerRadiusLegend[2].radiusColor
                            this.data.points[i].desc_legend = this.dealerRadiusLegend[2].desc
                            this.dealerRadiusLegend[2].count++
                            shape = 'pentagon'
                        }
                            
                        else{
                            color_border = this.dealerRadiusLegend[3].radiusColor
                            this.data.points[i].desc_legend = this.dealerRadiusLegend[3].desc
                            this.dealerRadiusLegend[3].count++
                            shape = 'hexagon'
                        }
                    }
                    
                    
                    
                        
                    let styleTextColor = styleText
                    styleTextColor += `
                        
                        left: 0rem;
                        top: 0rem;
                        
                    `
                    // Custom CSS for Different Shapes of Icon
                    if(shape == 'triangle') {
                        styleTextColor += `
                            border-left: 7px solid transparent;
                            border-right: 7px solid transparent;
                            
                            border-bottom: 11px solid ${color};
                        `
                    }
                    else if (shape == 'fa fa-star') {
                        styleTextColor += `color: ${color}`
                    }
                    else {
                        styleTextColor += `background-color: ${color};`
                    }

                    this.data.points[i].style = styleTextColor

                    let html = ''
                    if(shape == 'hexagon') {
                        html = `<span class="hexagon" style="color:${color};"></span>`
                    }
                    else if (shape == 'pentagon') {
                        html  = `<svg width="125%" height="125%" viewBox="-1 0 101 100" style="transform:rotate(180deg);left:-10px;top:-10px">
                                <path d="M20,0 L80,0 L100,60 L50,100 L0,60z" stroke="black" fill="${color}" />
                                </svg>`
                    }
                    else {
                        html = `<span style="${styleTextColor}" class="${shape}" />`
                    }

                    this.data.points[i].icon = divIcon({
                        className: "my-custom-pin",
                        iconAnchor: [0, 5],
                        labelAnchor: [-6, 0],
                        popupAnchor: [-12, -9],
                        html: html
                    })
                    let data = this.data.points[i]
                    // Set Hover Text for Icon
                    this.data.points[i].contentText = 
                    `
                        Owner Name : <b>${ data.owner_name }</b><br>
                        Alamat Domisli : <b>${ data.address ? data.address : '-' }</b><br>
                        Contact : <b>${ data.phone_number ? data.phone_number : '-' }</b><br>
                        Email : <b>${ data.email ? data.email : '-' }</b><br>
                        Purchase Dealer : <b>${ data.purchase_dealer }</b><br>
                        Engine Number : <b>${ data.engine_no }</b><br>
                        Vehicle Type : <b>${ data.type }</b><br>
                        Commercial Name : <b>${ data.commercial_name ? data.commercial_name : '-' }</b><br>
                        Delivery Date : <b>${ moment(data.activity_date).format('Y-MM-DD HH:mm')}</b><br>
                        Sales Date : <b>${ (data.sales_date == '-' ?  '-' : moment(data.sales_date).format('Y-MM-DD HH:mm')) }</b><br>
                        Service Date : <b>${(!data.last_service_date || data.last_service_date == '-' ?  '-' : moment(data.last_service_date).format('Y-MM-DD HH:mm'))}</b><br>
                        Lat : <b>${ data.lat }</b>, Lng :  <b>${ data.lng }</b><br>
                        Road Distance : <b>${ ((parseFloat(data.distance_road) / 1000).toFixed(2) )} KM</b><br>
                        Distance From Dealer : <b>${ ((parseFloat(distance)).toFixed(2))} KM</b>
                    `

                }

                

                let legend = []
                // Set Background Color For Every Icon
                for(var i = 0 ; i < legend.length ; i++) {
                    let color = legend[i].type == 'PURCHASE' ? '#F36F21': legend[i].type == 'BREACH' ?'#585FB7' : '#FF6289';

                    
                    let styleTextColor = styleText
                    styleTextColor += `
                        background-color: ${color};
                    `
                    legend[i].style = styleTextColor
                    legend[i].color = color
                }
                this.legendPoint = legend
            }
            // If data is Sales by Document, Count Every Ring Total
            else {

                let total = this.data.sales_summary.lokasi + this.data.sales_summary.ring_1 + this.data.sales_summary.ring_2  + this.data.sales_summary.ring_3 + this.data.sales_summary.other + this.data.sales_summary.pelanggaran_wilayah
                
                
                this.dealerRadiusLegend[0].count = this.data.sales_summary.lokasi
                this.dealerRadiusLegend[0].total = total

                this.dealerRadiusLegend[1].count = this.data.sales_summary.ring_1
                this.dealerRadiusLegend[1].total = total

                this.dealerRadiusLegend[2].count = this.data.sales_summary.ring_2
                this.dealerRadiusLegend[2].total = total

                this.dealerRadiusLegend[3].count = this.data.sales_summary.ring_3
                this.dealerRadiusLegend[3].total = total

                this.dealerRadiusLegend[4].count = this.data.sales_summary.other
                this.dealerRadiusLegend[4].total = total

                this.dealerRadiusLegend[5].count = this.data.sales_summary.pelanggaran_wilayah
                this.dealerRadiusLegend[5].total = total


            }

            this.$emit('showTotal' , this.dealerRadiusLegend)
            

            
            this.loading = false
            if(this.type != 'territorySalesByDocument')
                this.processedData = this.data.points.sort((a, b) => {return b.lat - a.lat})
            this.dealer = dealerData && dealerData.lat  ? [{lat : dealerData.lat , lng : dealerData.lng , dealer : dealerData}] : []

            this.$set(this, 'midPoints', midPoints)

            this.showData = this.processedData
            if(this.type != 'territorySalesByDocument')
                this.seperateKecamatan()

        }
    }
}
</script>

<style scoped>
    .hoverLegend:hover {
        background-color: black;
        color: white;
        border-radius: 3px;
    }

    .icon {
        width: 0.75rem;
        height: 0.75rem;
        display: block;
        position: relative;
        border-radius: 100%;
        /* background-color: #FFF; */
        background-color:#333
    }
    .col-12 {
        padding :0
    }

    .col-6 {
        padding-top: 0;
        padding-bottom: 0;
    }

    /* .hideButton {
        background-color: orange;
        border-radius: 30%;
        padding: 5px 2px;
    } */
    .headline {
        height : 25px !important;
        width : 25px !important;
        display : flex;
        justify-content: center;
        align-items : center;
        z-index: 99999;
    }
</style>

<style>
.custom-icon {
  background-color: white;
  padding: 7px;
  border: 1px solid #333;
  border-radius: 0 20px 20px 20px;
  box-shadow: 5px 3px 10px rgba(0, 0, 0, 0.2);
  text-align: center;
  width: auto !important;
  height: auto !important;
  margin: 0 !important;
}

.circle {
    border-radius: 3rem 3rem;
}
.diamond {
    height:100%;
    width:100%;
    position:relative;
    -webkit-transform: rotate(45deg);
    -moz-transform: rotate(45deg);
    transform: rotate(45deg);
    background-color: #333;
    content:'';
    display:block;
    position:absolute;
    /* left:-75%; */
    /* background-image:url(http://www.online-image-editor.com/styles/2013/images/example_image.png); */
    background-size:cover;
}

.hexagon::before {
  content: "\2B22";
  /* color: orange; */
  font-size:10px;
  left : -10px;
  top : -10px;
  position : relative;
}

.hexagonLegend::before {
  content: "\2B22";
  /* color: orange; */
  font-size:17px;
  left : -1px;
  top : -10px;
  position : relative;
}
.triangle {
    border-left: 7px solid transparent;
    border-right: 7px solid transparent;
    
    border-bottom: 11px solid #333;
    left: 0rem;
    top: 0rem;
    width: 0.75rem;
    height: 0.75rem;
    display: block;
    
    position: relative;
}

.rem-size-1 {
    width: 1rem !important;
    height: 1rem !important;
}
</style>